module.exports = __webpack_public_path__ + "img/dundrum_big.4873dfa4.png";